import { render } from "./cinemaSnack.vue?vue&type=template&id=9c98e7e2&scoped=true"
import script from "./cinemaSnack.vue?vue&type=script&lang=js"
export * from "./cinemaSnack.vue?vue&type=script&lang=js"

import "./cinemaSnack.vue?vue&type=style&index=0&id=9c98e7e2&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c98e7e2"]])

export default __exports__